import formBaseMongo from '../../../components/form/form-base-mongo.js'
import {EMPLOYEE_POSITIONS, EMPLOYEE_POSITION_DRIVER} from "../../../config/config"
import {core} from '../../../api/api-endpoints'

export default {
  mixins: [formBaseMongo],
  data () {
    return {
      tabView: 'tab1',
      fields: {
        fio: '',
        staff_position_id: '',
        personnel_number: '',
        phone: '',
        email: '',
        driver_class: ''
      }
    }
  },
  computed: {
    collections () {
      return this.$store.getters.readUrlEndpoint(
        this.getCollectionEndpoint()
      ) || {}
    },
    driverClasses() {
      return this.collections.driver_class
    },
    licenses() {
      return this.collections.license
    },
    positions () {
      return this.collections.staff_position
    }
  },
  methods: {
    getCollectionEndpoint() {
      return core.collection('license,driver_class,staff_position')
    },
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []

    if (methods.getCollectionEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getCollectionEndpoint()}))
    }

    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
